import React from "react";
import { Link } from "react-router-dom";
import financeImage from "../assets/cooperate.jpeg"; // Update this path to your actual image location

const AboutSection = () => {
  return (
    <section className="relative bg-[#fff] py-6 overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5 z-0">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/subtle-white-feathers.png')]"></div>
      </div>
      
      {/* Content container */}
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16 z-10">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-xl  sm:text-3xl md:text-3xl lg:text-4xl font-bold text-[#000300] mb-4">
            Strategic Capital Solutions
          </h2>
          <div className="w-24 h-1 bg-[#000300] mx-auto"></div>
        </div>

        {/* Content grid */}
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Text content */}
          <div className="lg:w-1/2">
            <h3 className="text-xl md:text-3xl font-semibold text-[#000300] mb-6">
              Empowering Your <span className="text-[#000300]">Financial Vision</span>
            </h3>
            <p className="text-[#000300] text-sm sm:text-lg md:text-lg lg:text-lg  leading-relaxed mb-8">
              At <span className="font-semibold text-[#000300]">EAP Finance</span>, we're more than just capital partners – we're the catalysts for your most ambitious dreams. We unlock the funding you need to propel growth, ignite innovation, and turn visionary ideas into reality. Our bespoke capital-raising solutions are designed to fuel your success, providing strategic financing that bridges the gap between possibility and achievement.

            </p>
            <p className="text-[#000300] text-sm sm:text-lg md:text-md lg:text-lg leading-relaxed mb-10">
              From scaling new heights to launching game-changing ventures, we're your trusted allies every step of the way. With customized financial strategies and unshakeable support, we empower you to seize opportunities, overcome challenges, and achieve greatness.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/solutions"
                 onClick={() => window.scrollTo(0, 0)}
                className="px-8 py-4 bg-[#000300] text-white font-semibold text-sm sm:text-lg md:text-lg lg:text-lg rounded-md hover:bg-gray-800 transition-all duration-300 hover:shadow-lg text-center"
              >
                Explore Our Solutions
              </Link>
              <Link
               onClick={() => window.scrollTo(0, 0)}
                to="/approach"
                className="px-8 py-4 border-2 border-[#000300] text-[#000300] font-semibold text-sm sm:text-lg md:text-md lg:text-lg rounded-md hover:bg-[#000300] hover:text-white transition-all duration-300 text-center"
              >
                Explore our approach
              </Link>
            </div>
          </div>

          {/* Image section with dark overlay */}
          <div className="lg:w-1/2 rounded-sm overflow-hidden shadow-xl relative">
            <img 
              src={financeImage} 
              alt="EAP Finance strategic capital solutions" 
              className="w-full h-full object-cover brightness-10" // Reduced brightness
              loading="lazy"
            />
            {/* Optional additional dark overlay for more control */}
            <div className="absolute inset-0 bg-black/5 mix-blend-multiply"></div>
          </div>
        </div>
      </div>

      {/* Separator */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent mt-10 md:mt-10 lg:mt-20 "></div>
    </section>
  );
};

export default AboutSection;